<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ "Announcements" }}
        </label>
      </v-system-bar>
      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="this.$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="300"
            height="60"
            class="report-title-text-mobile"
          >
            {{ "Announcements" }}</title-block
          >
        </v-flex>
      </v-layout>
      <v-row justify="space-between" class="ma-3">
        <v-col cols="12" lg="3" sm="6" md="6" xs="6">
          <v-text-field
            outlined
            dense
            clearable
            hide-details
            style="border-radius: 8px"
            prepend-inner-icon="mdi-magnify"
            :placeholder="'search'"
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          dark
          class="add_btn text-capitalize white--text"
          color="#A6CC39"
          style="border-radius: 8px !important"
          @click="AddAnnouncement()"
        >
          <v-icon style="color: #fffffff" class="mr-1" :small="true"
            >mdi-plus-box-outline</v-icon
          >
          <span style="font-size: 14px; color: #ffffff">{{
            "Add Announcements"
          }}</span>
        </v-btn>
      </v-row>
      <v-row class="ma-1">
        <v-col>
          <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="announcementItems"
            hide-default-footer
            :search="search"
            @page-count="pageCount = $event"
            :page.sync="page"
            :items-per-page="itemsPerPage"
          >
            <template v-slot:item.display="{ item }">
              <span
                :style="{
                  color: item.display === 'Show Now' ? 'green' : 'red'
                }"
              >
                {{
                  item.display === "Show Now"
                    ? $t("Show Now")
                    : $t("Don't Show")
                }}
              </span>
            </template>
            <template v-slot:item.orgImage="{ item }">
              <v-img
                :src="item.orgImage"
                class="articleimg"
                :class="{ inactivelist_img: !item.status }"
              >
                <v-sheet
                  height="20px"
                  width="60px"
                  line-height="30px"
                  class="statuss"
                  :style="
                    item.status
                      ? 'background-color:#6fdc42 '
                      : 'background-color: #c4c4c4'
                  "
                >
                  <v-icon
                    class="circle"
                    style="item.status? 'label: active
                  :label:inactive'"
                    >mdi-circle</v-icon
                  >
                  {{ item.status ? $t("active") : $t("inactive") }}
                </v-sheet>
              </v-img>
            </template>
            <template v-slot:item.startDate="{ item }">
              {{ item.startDate + " " + item.startTime }}
            </template>
            <template v-slot:item.endDate="{ item }">
              {{ item.endDate + " " + item.endTime }}
            </template>

            <template v-slot:item.viewTime="{ item }">
              <div v-if="item.viewTime === 0">
                <v-tooltip top color="#424242">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      class="detail-icon"
                      style="color: #424242; cursor: pointer"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.viewTime }}
                    </p>
                  </template>
                  <span>No View </span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip top color="#424242">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      class="detail-icon"
                      style="color: #424242; cursor: pointer"
                      v-bind="attrs"
                      v-on="on"
                      @click="GetViewDetail(item)"
                    >
                      {{ item.viewTime }}
                    </p>
                  </template>
                  <span>View Details</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.manage="{ item }">
              <v-btn
                text
                color="#4FB14E"
                class="text-capitalize"
                style="font-size: 16px"
                @click="EditAnnouncement(item)"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
                {{ "edit" }}
              </v-btn>
              <v-btn
                text
                color="#FF6060"
                style="font-size: 16px"
                class="text-capitalize"
                @click="checkAnnouncementDelete(item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
                {{ "delete" }}
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="space-between" class="mx-6 my-4">
        <v-row>
          <v-col cols="auto" class="mr-auto">
            <v-pagination
              circle
              v-model="page"
              class="pagination"
              :length="pageCount"
            ></v-pagination>
          </v-col>
          <v-col cols="12" lg="2" md="3" sm="4" class="d-flex justify-end">
            <p class="mt-3 pr-4">{{ "Show" }}</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  width="70"
                  v-bind="attrs"
                  v-on="on"
                  style="border: 1px solid #c0c0c0; opacity: 1"
                  class="text-capitalize mt-1"
                  outlined
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in paginationCount"
                  :key="index"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
    <v-dialog v-model="detaildialog" width="732" persistent :scrollable="true">
      <v-card>
        <v-card-title style="font-size: 20px; height: 50px">
          <v-icon
            class="mr-1"
            style="padding-bottom: 3px; color: #363636; font-size: 30px"
            >mdi-alert-circle-outline</v-icon
          >
          {{ "Detail" }}
          <v-spacer></v-spacer>
          <v-btn
            @click="detaildialog = false"
            icon
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-0">
          <v-row class="mt-1 ml-2">
            <v-col cols="12" lg="6" xl="6" md="6" sm="6">
              <v-row>
                <v-col
                  cols="12"
                  lg="4"
                  xl="4"
                  md="6"
                  sm="6"
                  class="pb-3 pr-0 pl-3"
                >
                  <label
                    style="
                      font-size: 16px;
                      color: #47484b;
                      font-weight: bold;
                      margin-top: 5px;
                    "
                    >{{ $t("title") }}:</label
                  >
                </v-col>
                <v-col class="pb-3 pl-0">
                  <label
                    style="font-size: 16px; color: #47484b; margin-top: 5px"
                    >{{ detail.title }}</label
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" xl="6" md="6" sm="6">
              <v-row>
                <v-col cols="12" lg="6" xl="5" md="6" sm="6" class="pr-0 pb-3">
                  <label
                    style="
                      font-size: 16px;
                      color: #47484b;
                      font-weight: bold;
                      margin-top: 5px;
                    "
                    >{{ $t("viewall") }}:</label
                  >
                </v-col>
                <v-col class="pl-1 pb-3">
                  <label
                    style="font-size: 16px; color: #47484b; margin-top: 5px"
                    >{{ detail.viewTime }}</label
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            loading-text="Loading... Please wait"
            :headers="detailsheader"
            :items="DetailsList"
            hide-default-footer
            :search="search"
            @page-count="detailpageCount = $event"
            :page.sync="detailpage"
            :items-per-page="itemsPerPage"
          >
          </v-data-table>
          <v-row justify="space-between" class="ma-3"> </v-row>
        </v-card-text>
        <v-row justify="space-between" class="mx-6 my-4">
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-pagination
                circle
                v-model="detailpage"
                class="pagination"
                :length="pagesCount"
              ></v-pagination>
            </v-col>
            <v-col cols="12" lg="2" md="3" sm="4" class="d-flex justify-end">
              <p class="mt-3 pr-4">{{ "Show" }}</p>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    width="70"
                    v-bind="attrs"
                    v-on="on"
                    style="border: 1px solid #c0c0c0; opacity: 1"
                    class="text-capitalize mt-1"
                    outlined
                  >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in detailpageCount"
                    :key="index"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-row>
      </v-card>
    </v-dialog>
    <v-progress-circular
      v-if="loading"
      indeterminate
      class="loading-circle"
      color="green"
    ></v-progress-circular>
    <DeleteConfirmDialog
      :show="deleteDialog"
      @close="(deleteDialog = false), GetAnnouncement()"
      @confirm="handleConfirm"
    />
    <SuccessDialog
      :show="successDialog"
      :title="$t('success')"
      :text="message"
      @close="successDialog = false"
    />
    <Add
      ref="AddAnnouncement"
      :show="addDialog"
      @close="(addDialog = false), GetAnnouncement()"
      :full_name="fullName_"
      @confirm="
        (addDialog = false),
          (successDialog = true),
          ((message = 'Adding new Announcement is successful.'),
          GetAnnouncement())
      "
    />
    <Edit
      :show="editDialog"
      :full_name="fullName_"
      @close="(editDialog = false), GetAnnouncement()"
      @confirm="
        (editDialog = false),
          (successDialog = true),
          ((message = 'Update Announcement Successful'), GetAnnouncement())
      "
    />
  </div>
</template>
<script>
import TitleBlock from "@/components/global_component/TitleBlock";
import DeleteConfirmDialog from "@/components/DeleteConfirmDialog.vue";
import SuccessDialog from "@/components/SuccessDialog.vue";
import axios from "axios";
import Add from "./addannouncement.vue";
import Edit from "./editannouncement.vue";
import enurl from "@/api/environment";
import store from "@/store";
import * as moment from "moment/moment";

export default {
  name: "report",
  components: {
    TitleBlock,
    Add,
    Edit,
    DeleteConfirmDialog,
    SuccessDialog
  },
  data() {
    return {
      updateDate: "",
      url: enurl.apiUrl,
      search: "",
      page: 1,
      detailpage: 1,
      pagesCount: 1,
      pageCount: 0,
      itemsPerPage: 10,
      detailpageCount: 0,
      paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
      addDialog: false,
      editDialog: false,
      fullName_: "",
      deleteData: {},
      deleteDialog: false,
      message: "",
      loading: false,
      announcementItems: [],
      DetailsList: [],
      detail: {
        title: "",
        viewTime: ""
      },
      detailV: {
        title: "",
        companyCode: "",
        companyName: "",
        pretestPassScore: "",
        view: ""
      },
      successDialog: false,
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      detaildialog: false
    };
  },
  computed: {
    detailsheader() {
      //for article & leasson learn tab
      return [
        {
          text: this.$t("companycode"),
          value: "companyCode",
          align: "left"
        },
        {
          text: this.$t("companyname"),
          value: "companyName",
          align: "left"
        },
        {
          text: this.$t("view"),
          value: "viewTime",
          align: "left"
        }
      ];
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "no",
          width: "63px",
          sortable: true
        },
        {
          text: this.$t("cover"),
          align: "left",
          value: "orgImage",
          width: "150px",
          sortable: false
        },
        {
          text: this.$t("title"),
          align: "left",
          value: "title",
          width: "180px",
          sortable: true
        },
        {
          text: this.$t("startdate"),
          align: "center",
          value: "startDate",
          width: "150px",
          sortable: true
        },
        {
          text: this.$t("time"),
          align: "center",
          value: "endDate",
          width: "150px",
          sortable: true
        },
        {
          text: this.$t("createdate"),
          align: "center",
          value: "createDate",
          width: "160px",
          sortable: true
        },
        {
          text: this.$t("display"),
          align: "center",
          value: "display",
          width: "160px",
          sortable: true
        },
        {
          text: this.$t("view"),
          align: "center",
          value: "viewTime",
          width: "160px",
          sortable: true
        },
        {
          text: this.$t("manage"),
          align: "center",
          value: "manage",
          width: "235px",
          sortable: false
        }
      ];
    },
    items() {
      return [
        {
          img: require("@/assets/imgs/img-01@3x.png"),
          title: "Sample",
          numberofadd: 2,
          numberofviews: 1,
          create_Date: "26/6/2023"
        }
      ];
    }
  },

  mounted: function() {
    this.GetAnnouncement();
    console.log("all data", this.items);
  },
  methods: {
    handleConfirm() {
      this.deleteDialog = false;
      this.successDialog = true;
      this.message = "Delete  Announcement is successful.";
      this.confirmDelete();
      this.GetAnnouncement();
    },
    async GetViewDetail(item) {
      console.log("item", item);
      let that = this;
      that.DetailsList = [];
      that.detaildialog = "true";
      // let self = this;
      that.detail.title = item.title;
      that.detail.viewTime = item.viewTime;
      that.loading = true;
      axios
        .get(
          `${that.url}Announcement/GetAnnouncementDetail?AnnouncementID=${item.id}`
        )
        .then(function(response) {
          console.log("DetailsList", response);
          that.DetailsLists = response.data.data.map((v, i) => ({
            ...v,
            no: i + 1
          }));
          that.loading = false;
          that.DetailsList = that.DetailsLists;
          console.log("DetailsList", that.DetailsList);
        })
        .catch(function() {});
    },
    async EditAnnouncement(item) {
      let self = this;

      let newstarttime = item.startTime.split(" ");
      let startTime = newstarttime[0];
      let resStartTime = null;
      if (newstarttime[1] == "PM") {
        let separatetime = parseInt(startTime.split(":")[0]);
        let addtime = separatetime == 12 ? separatetime : separatetime + 12;
        resStartTime = addtime + ":" + startTime.split(":")[1];
      } else {
        if (startTime.split(":")[0] <= 9) {
          resStartTime =
            0 + startTime.split(":")[0] + ":" + startTime.split(":")[1];
        } else {
          resStartTime = startTime;
        }
      }
      item.startTime = resStartTime;

      let newendtime = item.endTime.split(" ");
      let endTime = newendtime[0];
      let resEndTime = null;
      if (newendtime[1] == "PM") {
        let separateendtime = parseInt(endTime.split(":")[0]);
        let endaddtime =
          separateendtime == 12 ? separateendtime : separateendtime + 12;
        resEndTime = endaddtime + ":" + endTime.split(":")[1];
      } else {
        if (endTime.split(":")[0] <= 9) {
          resEndTime = 0 + endTime.split(":")[0] + ":" + endTime.split(":")[1];
        } else {
          resEndTime = endTime;
        }
      }
      item.endTime = resEndTime;
      const startdatedata = item.startDate.split("/");
      const enddatedata = item.endDate.split("/");
      item.startDate =
        startdatedata[2] + "-" + startdatedata[1] + "-" + startdatedata[0];
      item.endDate =
        enddatedata[2] + "-" + enddatedata[1] + "-" + enddatedata[0];
      store.commit("saveEditAnnouncement", {
        ...item
      });
      store.commit("showFirstTimeEditDataForAnnouncement");
      self.editDialog = true;
    },
    async AddAnnouncement() {
      let self = this;
      self.$refs.AddAnnouncement.setFileNull();
      self.addDialog = true;
    },
    async GetAnnouncement() {
      let self = this;
      self.loading = true;
      axios
        .get(`${self.url}Announcement/GetAllAnnouncement`)
        .then(function(response) {
          self.announcementItems = response.data.data.map((v, i) => ({
            ...v,
            no: i + 1,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY"),
            startDate: moment(v.startDate)
              .local()
              .format("DD/MM/YYYY"),
            startTime: moment(v.startTime)
              .local()
              .format("LT"),
            endTime: moment(v.endTime)
              .local()
              .format("LT"),
            endDate: moment(v.endDate)
              .local()
              .format("DD/MM/YYYY"),
            updateDate: moment(v.updateDate)
              .local()
              .format("DD/MM/YYYY")
          }));
          self.loading = false;
        })
        .catch(function(error) {});
    },
    async checkAnnouncementDelete(item) {
      let self = this;
      self.deleteData = item;
      self.deleteDialog = true;
    },

    async confirmDelete() {
      let self = this;
      self.loading = true;
      await axios
        .post(
          `${self.url}Announcement/DeleteAnnouncement?ID=` + self.deleteData.id
        )
        .then(function(res) {
          self.successDialog = true;
          self.deleteDialog = false;
          self.loading = false;
          self.GetAnnouncement();
        })
        .catch(function(err) {
          alert(err);
        });
    },
    closesuccessdialog() {
      let self = this;
      self.successDialog = false;
      self.GetAnnouncement();
    }
  }
};
</script>

<style scoped>
::v-deep .detail-icon {
  cursor: pointer;
  outline: none !important;
}
.loading-circle {
  position: fixed;
  z-index: 5;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}
.articleimg {
  margin: 10px 0px;
  border-radius: 20px;
  height: 285px;
  width: 175px !important;
}
.circle {
  margin-bottom: 2px;
  color: white !important;
  font-size: 8px !important;
  /* padding: 1px; */
}
.statuss {
  border-radius: 6px;
  font-size: 11px;
  text-align: center;
  padding: 2px;
  margin: 12px;
  background: #6fdc42;
  color: #ffffff;
  display: inline-table;
}
.inactivelist_img {
  border-radius: 12px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.add_btn {
  margin-top: 15px;
  margin-right: 12px;
  color: #fff;
  font-size: 18px;
  z-index: 0;
  position: relative;
  display: inline-block;
}
.add_btn:before {
  background-color: #4fb14e;
  content: "";
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  opacity: 0.5 !important;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
}
.add_btn:hover:before {
  background-color: #4fb14e;
  top: 0;
}
.add_btn:hover {
  transition: 0.25s;
}
.add_btn:after {
  position: absolute;
  right: 2.34375rem;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(50%);
  -ms-transform: translateY(-50%) translateX(50%);
  transform: translateY(-50%) translateX(50%);
}
/* ::v-deep .v-pagination__item {
  opacity: 1 !important;
} */
::v-deep tr:nth-child(even) {
  background: unset;
}
::v-deep .v-label {
  font-size: 20px !important;
}
::v-deep .v-text-field__slot {
  font-size: 20px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
  vertical-align: top;
}
::v-deep .v-dialog {
  border-radius: 35px !important;
}
::v-deep .primary {
  color: #000000 !important;
  background-color: #a6cc39 !important;
  opacity: 1;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  opacity: 1;
}

/* For Sort menu. */
::v-deep .sort_Btn.v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px;
  font-size: 16px;
  border: 1px solid #c0c0c0; /**#47484b */
  border-radius: 8px;
  opacity: 1 !important;
  padding: 0 0;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar {
  width: 7px !important;
}
/* Track */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-track {
  width: 6px !important;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}
/* Handle */
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}
::v-deep .v-list.overflow-y-auto.v-sheet.theme--light {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}
::v-deep .v-list-item {
  min-height: 32px;
  border-top: 2px solid #707070;
}
::v-deep .v-list-item:hover {
  background-color: #707070 !important;
}
::v-deep
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  color: #ffffff !important;
}
/* end sort menu. */
</style>

<style scoped>
@media (min-width: 1264px) {
  .container {
    max-width: unset !important;
    margin-top: 1.5rem !important;
  }
}
::v-deep .v-data-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}
::v-deep .v-data-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}
</style>
